import { Routes } from '@angular/router';
import { DashboardContainerComponent } from './containers/dashboard-container/dashboard-container.component';

export const dashboardRoutes:Routes = [
    {
        path:'',
        component: DashboardContainerComponent
    }
]